import { render, staticRenderFns } from "./acountsafe.vue?vue&type=template&id=d717add0&scoped=true&"
import script from "./acountsafe.vue?vue&type=script&lang=js&"
export * from "./acountsafe.vue?vue&type=script&lang=js&"
import style0 from "./acountsafe.vue?vue&type=style&index=0&id=d717add0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d717add0",
  null
  
)

export default component.exports